export default "__VITE_ASSET__DnM37OAZ__"